import { render } from "./ItemEmptyPanel.vue?vue&type=template&id=89f61720&scoped=true&ts=true"
import script from "./ItemEmptyPanel.vue?vue&type=script&lang=ts"
export * from "./ItemEmptyPanel.vue?vue&type=script&lang=ts"

import "./ItemEmptyPanel.vue?vue&type=style&index=0&id=89f61720&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89f61720"]])

export default __exports__